






























































































































































































































































































































































import Vue from 'vue'
import {
  Parameter,
  StatusParameter,
  GetListOfStatusParameter,
  CreateParameter,
} from '@/api/cems'
import { Find as FindDevice } from '@/api/device'
import { Device } from '@/types/device'

export default Vue.extend({
  name: 'FormEditParameter',
  data() {
    return {
      listStatusParameter: [] as StatusParameter[],
      parameter: { tag: {} } as Parameter,
      devices: [] as Device[],
    }
  },
  methods: {
    async getListStatusParameter() {
      this.listStatusParameter = await GetListOfStatusParameter()
    },
    async createParameter() {
      await CreateParameter(this.parameter)
    },

    async findDevices() {
      this.devices = await FindDevice()
    },

    async onSubmit(e: Event) {
      e.preventDefault()
      await this.createParameter()
      this.$router.push(
        `/cems/setting/chimney/${this.parameter.stackUid}/parameter`
      )
    },
  },

  async created() {
    this.parameter.stackUid = this.$route.params.stackUID
    await this.getListStatusParameter()
    await this.findDevices()
  },
})
